import Repository from './Repository'

const resource = '/custom/reviews'

export default {
    get(data) {
        return Repository.get(`${resource}`)
    }
}
